import { Link } from 'react-router'
import { Add, Delete, Edit, KeyboardReturn, Launch, OpenInFullOutlined } from '../Icons'
import { Stack, type StackProps } from '../Layout'
import { Tooltip } from '../Display'
import { IconButton, type IconButtonProps } from '../Buttons'

export function ActionGutter({ actions = [], sx, ...props }: ActionGutterProps) {
  return (
    <Stack sx={{ position: 'absolute', top: '0.75rem', right: '0.75rem', ...sx }} {...props}>
      {actions.map(action => (
        <StyledIconButton
          key={action.type}
          value={action.intent}
          type={action.intent ? 'submit' : 'button'}
          name={action.intent && 'intent'}
          onClick={e => action.callback && action.callback(e)}
          sx={{
            my: 1,
            alignItems: 'flex-start',
            backgroundColor: 'white',
            borderRadius: '0.5rem',
            boxShadow: theme => theme.elevation.button,
          }}
        >
          <Tooltip placement='top' title={action.title}>
            {getActionIcon(action.type, action.link ?? undefined)}
          </Tooltip>
        </StyledIconButton>
      ))}
    </Stack>
  )
}

/** HELPERS */
const StyledIconButton = ({ sx, ...props }: IconButtonProps) => (
  <IconButton disableRipple size='small' edge='end' sx={{ ...sx }} {...props} />
)

function getActionIcon(type: PublicActions, link?: string) {
  switch (type) {
    case 'add':
      return <Add sx={{ p: 0.5 }} />
    case 'delete':
      return <Delete sx={{ p: 0.5 }} />
    case 'edit':
      return <Edit sx={{ p: 0.5 }} />
    case 'link':
      return (
        <Link to={link ?? ''}>
          <Launch
            sx={{
              opacity: 0.54,
              p: 0.5,
            }}
          />
        </Link>
      )
    case 'restore':
      return <KeyboardReturn sx={{ p: 0.5 }} />
    case 'zoom':
      return <OpenInFullOutlined sx={{ p: 0.5 }} />
  }
}

/** TYPES */
export type PublicActions = 'add' | 'delete' | 'edit' | 'link' | 'restore' | 'zoom'

export interface Action {
  type: PublicActions
  title: string
  intent?: string
  link?: string
  callback?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

interface ActionGutterProps extends Omit<StackProps, 'action'> {
  actions?: Action[]
}
